// extracted by mini-css-extract-plugin
export var card = "_j7-5";
export var cardSelected = "_j7-4";
export var image = "_j7-3";
export var modal = "_j7-0";
export var modalContent = "_j7-1";
export var table = "_j7-2";